<!--全部服务分类-->
<template>
  <div class="service-container">
    <headerIndex/>
    <div class="service-content">
      <div class="SourceHanSansCN title">
        <p>{{ pName }}</p>
        <div class="search-right">
          <el-input class="search-input" placeholder="请输入关键词" @keyup.enter.native="searchShop" v-model="keyword">
            <span class="red-btn SourceHanSansCN" slot="suffix" @click="searchShop">搜索</span>
          </el-input>
          <div class="recommend-search">
            <el-link v-for="rec of recommendSearch" @click="checkRecommend(rec)">{{ rec }}</el-link>
          </div>
        </div>
      </div>
    </div>
    <div class="title-hang">
      <el-link :underline="false" @click="changeServiceType" style="color: #ffffff;font-size: 16px;">全部服务分类
        {{ serviceList != null ? '> ' + serviceList.name : '' }}
        {{ serviceData != null ? '> ' + serviceData.name : '' }}
      </el-link>
    </div>
    <div class="recommend-list" :style="'min-height:'+min_height+'px;'">
      <div class="condition-label">
        <i class="multiple" @click="changeSearchType">综合</i>
        <i class="multiple" style="padding-right: 30px;" @click="ascPrice">价格
          <i :class="sort==1 ? 'el-icon-caret-top isActive' : 'el-icon-caret-top'"/>
          <i :class="sort==2 ? 'el-icon-caret-bottom isActive' : 'el-icon-caret-bottom'"/>
        </i>
        <i class="multiple" style="padding-right: 30px;" @click="ascSale">销量
          <i :class="sort==3 ? 'el-icon-caret-top isActive' : 'el-icon-caret-top'"/>
          <i :class="sort==4 ? 'el-icon-caret-bottom isActive' : 'el-icon-caret-bottom'"/>
        </i>
      </div>
      <div class="recommend">
        <el-row :gutter="16">
          <el-col :span="4" v-for="recommend of recommends" style="cursor: pointer;">
            <div @click="productDetails(recommend)">
              <el-image style="width: auto; height: 230px;border-radius: 8px;" :src="recommend.image" fit="contain"
                        v-if="recommend.image"/>
              <el-empty description="暂无商品图片" style="width: auto; height: 230px;border-radius: 8px;" v-else/>
              <p class="recommend-title SourceHanSansCN">{{ recommend.name }}</p>
              <div class="preferential-amount" v-if="recommend.usingDoor">
                <div class="preferential">满{{ recommend.usingDoor }}减{{ recommend.preferentialAmount }}</div>
              </div>
              <p class="recommend-price SourceHanSansCN"><span>￥</span>{{ parseFloat(recommend.price).toFixed(2) }}</p>
            </div>
          </el-col>
        </el-row>
      </div>
      <!-- 分页 -->
      <page :total="tablePage.total" class="pagination" @currentPage="currentPage" :page="tablePage.currentPage"
            :limit="tablePage.pageSize" style="padding: 20px 25px 15px 10px;"/>
    </div>
    <el-dialog title="" :visible.sync="dialogVisible" width="50%" :show-close="false" top="60px" :lock-scroll="true">
      <el-container>
        <el-aside style="width: auto;">
          <el-radio-group v-model="oneService" @change="changeOneService">
            <el-radio-button v-for="one of oneServiceList" :label="one.id">{{ one.name }}
              <i class="el-icon-arrow-right"/>
            </el-radio-button>
          </el-radio-group>
        </el-aside>
        <el-main>
          <p style="font-size: 16px;color: #333333;margin-block-end: 0em;" class="SourceHanSansCN">
            {{ showOneService.name }}</p>
          <el-link type="info" v-for="(sonList,index) of showOneService.sonList" :underline="false"
                   @click="changeServiceClass(sonList)">{{ sonList.name }}
            <el-divider direction="vertical" class="divider-el" v-if="index!=showOneService.sonList.length-1"/>
          </el-link>
          <el-divider/>
        </el-main>
      </el-container>
    </el-dialog>
    <Hangs/>
    <home_footer/>
  </div>
</template>

<script>
import headerIndex from "@/components/header/headerIndex";
import home_footer from "@/components/footer/home_footer";
import page from "@/components/page/pages";
import Hangs from "@/components/Hang/Hangs";
import cityJson from "@/static/cityJson.json";
import {classificationSonsOnes} from "@/api/systemSetting";
import {hotSearchKeywords, pcShopGoodsForSearchPrice} from '@/api/cloudServiceApi'

export default {
  name: "AllService",
  components: {headerIndex, home_footer, Hangs, page},
  data() {
    return {
      pName: '企业数字化服务云平台',
      recommends: [],
      keyword: '',
      /*分页*/
      tablePage: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      showConnect: false,
      timer: null,
      recommendSearch: [],
      min_height: document.documentElement.clientHeight - 469,
      cityList: {},
      cid: 0,
      dialogVisible: false,
      oneServiceList: [],
      oneService: 1,
      showOneService: {},
      salesOrder: false,
      priceSort: 0,
      serviceData: null,
      searchType: 1,
      serviceList: null,
      sort: 0,
    }
  },
  methods: {
    /*获取搜索推荐*/
    getHotSearchKeywords() {
      hotSearchKeywords().then(res => {
        if (res.code == 200) {
          this.recommendSearch = res.content.list;
        }
      })
    },
    /*键入推荐搜索*/
    checkRecommend(val) {
      this.keyword = val;
    },
    /*产品详情*/
    productDetails(rows) {
      sessionStorage.setItem('serviceList', this.serviceList != null ? JSON.stringify(this.serviceList) : '')
      sessionStorage.setItem('serviceData', this.serviceData != null ? JSON.stringify(this.serviceData) : '')
      this.$router.push({
        path: '/cloudPlatform/productDetails',
        query: {
          id: rows.id,
          pName: this.pName
        }
      })
    },
    /*修改服务分类*/
    changeServiceType() {
      this.dialogVisible = true;
    },
    /*选择一级服务分类*/
    changeOneService(value, event) {
      for (let one of this.oneServiceList) {
        if (one.id == value) {
          this.serviceList = one;
          this.showOneService = one;
        }
      }
    },
    /*获取服务分类*/
    getClassificationSonsOnes() {
      let that = this;
      classificationSonsOnes().then(res => {
        if (res.code == 200) {
          that.oneServiceList = res.content.newClass;
          if (that.$route.query.one) {
            let one = that.$route.query.one
            for (let service of that.oneServiceList) {
              if (service.id == one) {
                that.serviceList = service;
                that.showOneService = service;
                if (that.$route.query.second) {
                  let second = that.$route.query.second;
                  for (let sonList of service.sonList) {
                    if (second == sonList.id) {
                      that.serviceData = sonList;
                    }
                  }
                }
              }
            }
          }
        }
      })
    },
    //切换分页
    currentPage(page) {
      this.tablePage.currentPage = page;
      this.getNewHomeSearch();
    },
    /*获取商品信息*/
    getNewHomeSearch() {
      pcShopGoodsForSearchPrice({
        page: this.tablePage.currentPage,//分页
        pageLimit: this.tablePage.pageSize,/*每页条数*/
        pid: this.serviceData ? parseInt(this.serviceData.id) : 0,/*分类id*/
        userId: this.cid != 0 && this.cid != undefined ? this.cid : 0,/*用户id*/
        sort: this.sort,/*排序方式 0 默认 综合 、1：价格升序，2：价格降序，3：销量升序，4：销量降序*/
        keyword: this.keyword,/*关键字*/
      }).then(res => {
        if (res.code == 200) {
          this.recommends = res.content.BqwGoods;
          this.tablePage.total = res.content.totalNum;
        }
      })
    },
    /*搜索--价格*/
    ascPrice() {
      if (this.sort != 1) {
        this.sort = 1;
      } else {
        this.sort = 2;
      }
      this.tablePage.currentPage = 1;
      this.getNewHomeSearch();
    },
    /*搜索--销量*/
    ascSale() {
      if (this.sort != 4) {
        this.sort = 4;
      } else {
        this.sort = 3;
      }
      this.tablePage.currentPage = 1;
      this.getNewHomeSearch();
    },
    /*修改服务分类，调用商品查询功能*/
    changeServiceClass(row) {
      this.serviceData = row;
      this.sort = 0;
      this.dialogVisible = false;
      this.tablePage.currentPage = 1;
      this.getNewHomeSearch();
    },
    /*切换综合查询*/
    changeSearchType() {
      this.sort = 0;
      this.tablePage.currentPage = 1;
      this.getNewHomeSearch();
    },
    /*关键字搜索*/
    searchShop() {
      this.sort = 0;
      this.tablePage.currentPage = 1;
      this.getNewHomeSearch();
    }
  },
  mounted() {
    this.getHotSearchKeywords();
    this.getNewHomeSearch();
  },
  beforeMount() {
    this.getClassificationSonsOnes();
    if (this.$route.query.keyword) {
      this.keyword = this.$route.query.keyword;
    }
    this.cid = sessionStorage.getItem('loginData') != '' && sessionStorage.getItem('loginData') != null && sessionStorage.getItem('loginData') != undefined ? JSON.parse(sessionStorage.getItem('loginData')).cid : 0;
    this.pName = this.$route.query.pName;
    if (sessionStorage.getItem('setPositioning'))
      this.cityList = JSON.parse(sessionStorage.getItem('setPositioning'));
    else {
      let cityList = JSON.parse(sessionStorage.getItem('locationInfo'));
      for (let li of cityJson) {
        if (cityList.short_name == li.short_name)
          this.cityList = li;
      }
    }
  }
}
</script>
<style scoped>
.service-container >>> .service-content .el-input__prefix {
  left: 10px;
  transition: all .3s;
  font-size: 18px;
  font-weight: bold;
  padding-top: 7px;
}

.service-container >>> .service-content .el-input__suffix {
  right: 0px;
  transition: all .3s;
  pointer-events: none;
  padding-top: 0px;
}

.service-container >>> .service-content .el-input__inner:hover {
  border-color: #FE273B;
}

.service-container >>> .el-radio-group {
  width: min-content;
}

.service-container >>> .el-dialog__header {
  padding: 0;
}

.service-container >>> .el-dialog__body {
  padding: 0px;
}

.service-container >>> .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  color: #FD2F37;
  background-color: white;
  border-color: white;
  box-shadow: none;
}

.service-container >>> .el-radio-button__inner {
  background: #F1F1F1;
  border: none;
  color: #666666;
  padding: 20px 120px 20px 30px;
  font-size: 16px;
  border-bottom: 1px solid #DDDDDD;
}

.service-container >>> .el-icon-arrow-right {
  position: absolute;
  right: 20px;
  color: #333333;
}

.service-container >>> .el-link.el-link--info {
  color: #666666;
  padding-top: 10px;
}
</style>
<style scoped lang="scss">
.service-container {
  background: white;

  .service-content {
    padding: 0px 18%;
    background: white;
    min-width: 76rem;

    .title {
      display: flex;
      justify-content: space-between;
      height: 90px;
      padding-top: 1em;
      p{
        font-size: 36px;
        cursor: context-menu;
        margin-block-start: 0em;
        margin-block-end: 0em;
      }
      .search-right{
        width: 480px;
        text-align: left;
        .search-input {
          width: 100%;
          float: right;
          margin-top: 6px;
          border: 1px solid #FE273B;
          border-radius: 6px;

          .red-btn {
            display: inline-block;
            width: 80px;
            height: 100%;
            background-color: #fd2f37;
            font-size: 16px;
            color: #ffffff;
            text-align: center;
            line-height: 40px;
            cursor: pointer;
            border-radius: 4px;
          }
        }
        .recommend-search {
          width: inherit;
          margin-block-start: 0em;
          margin-block-end: 0em;
          height: 40px;
          display: flex;
          flex-wrap: wrap;
          align-items: baseline;
          justify-content: left;

          .el-link {
            margin-right: 20px;
            font-size: 14px;
            color: #666666;
          }
        }
      }
    }


  }

  .title-hang {
    background: #1E4165;
    padding: 10px 18%;
    color: #FFFFFF;
    font-size: 20px;
    cursor: pointer;
    display: flex;
    justify-content: left;
    align-items: center;
    min-width: 76rem;
  }

  .recommend-list {
    background: #F5F5F5;
    padding: 20px 18% 10px;
    min-width: 76rem;

    .condition-label {
      padding-bottom: 20px;

      .multiple {
        font-style: normal;
        color: #333333;
        font-size: 16px;
        padding: 5px 20px;
        border: 1px solid #DDDDDD;
        margin-right: 20px;
        cursor: pointer;

        .el-icon-caret-top {
          position: absolute;
          margin-top: -3px;
          color: #999999;
        }

        .el-icon-caret-top:hover {
          color: #0067DD;
        }

        .el-icon-caret-bottom {
          position: absolute;
          margin-top: 6px;
          color: #999999;
        }

        .el-icon-caret-bottom:hover {
          color: #0067DD;
        }

        .isActive {
          color: #1637FF;
        }
      }
    }

    .recommend {
      padding: 20px 20px;
      background: white;

      .el-col-4 {
        width: 20%;
        padding-bottom: 20px;
        min-height: 338px;

        .recommend-title {
          margin-block-start: 0;
          margin-block-end: 0;
          font-size: 16px;
          color: #333333;
          padding: 0px 0px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          word-wrap: break-word;
          word-break: break-all;
        }

        .recommend-price {
          font-size: 18px;
          color: #FE273B;
          margin-block-start: 0;
          margin-block-end: 0;

          span {
            font-size: 14px;
            padding-right: 3px;
          }
        }

        .preferential-amount {
          cursor: pointer;
          line-height: 24px;
          text-align: center;
          font-size: 14px;
          color: #FE273B;

          .preferential {
            background: url("~@/assets/img/cloud/coupon.png");
            width: 120px;
            height: 24px;
            background-size: 100% 100%;
          }
        }
      }
    }
  }
}
</style>